import { render, staticRenderFns } from "./RadialCheckbox.vue?vue&type=template&id=6cb8d4b2&scoped=true"
import script from "./RadialCheckbox.vue?vue&type=script&lang=js"
export * from "./RadialCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RadialCheckbox.vue?vue&type=style&index=0&id=6cb8d4b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb8d4b2",
  null
  
)

export default component.exports